<template>
  <div class="dash-box-mian">
    <div class="dash-box" :style="styObj">
      <!-- 外边框 -->
      <div class="outer-border">
        <div class="outer-back">
          <div class="inner-wrapper">
            <!-- 内边框 -->
            <div class="inner-border">
              <!-- 中间边框 -->
              <!--<div class="center-box"></div>-->
            </div>
          </div>
        </div>
      </div>

      <div class="inner-middle">
        <div class="middle-content">
          <div class="middle-back">
            <div class="middle-name">{{ `${!isNaN(Number(currentRate)) ? currentRate : 0}%` }} {{ rateShow }}</div>
            <div class="middle-msg">已完成</div>
          </div>
        </div>
      </div>


      <!-- 中间白圆点 -->
      <div class="center-dot"></div>
      <!-- 中间指针 -->
      <div class="center-pointer-wrapper">
        <div class="center-pointer"></div>
      </div>
      <!-- 刻度线及刻度数字 -->
      <div class="line-tick line-tick1">
        <div class="tick"></div>
        <!--<div class="num">0</div>-->
      </div>

      <div class="line-tick line-tick1-1">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick1-2">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick1-3">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick2">
        <div class="tick"></div>
        <!--<div class="num">20</div>-->
      </div>

      <div class="line-tick line-tick2-1">
        <div class="tick"></div>
      </div>
      <div class="line-tick line-tick2-2">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick2-3">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick3">
        <div class="tick"></div>
        <!--<div class="num">40</div>-->
      </div>

      <div class="line-tick line-tick3-1">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick3-2">
        <div class="tick"></div>
      </div>
      <div class="line-tick line-tick3-3">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick4">
        <div class="tick"></div>
        <!--<div class="num">60</div>-->
      </div>

      <div class="line-tick line-tick4-1">
        <div class="tick"></div>
      </div>
      <div class="line-tick line-tick4-2">
        <div class="tick"></div>
      </div>
      <div class="line-tick line-tick4-3">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick5">
        <div class="tick"></div>
        <!--<div class="num">80</div>-->
      </div>

      <div class="line-tick line-tick5-1">
        <div class="tick"></div>
      </div>
      <div class="line-tick line-tick5-2">
        <div class="tick"></div>
      </div>
      <div class="line-tick line-tick5-3">
        <div class="tick"></div>
      </div>

      <div class="line-tick line-tick6">
        <div class="tick"></div>
        <!--<div class="num">100</div>-->
      </div>
      <!--<div class="slot-content">
         <slot></slot> 
        <span class="slot-text">{{ `${currentRate}%` }} {{ rateShow }}</span>
      </div>-->
    </div>
  </div>
</template>

<script>
import { parseNumber } from '@/utils'
export default {
  name: "Login",
  props: {
    height: {
      type: Number,
      default: 320
    },
    item: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      currentRate: 0,
      rate: 0
    };
  },
  created() {
    let rate = 0;
    setInterval(() => {
      if (isNaN(Number(this.currentRate))) {
        this.currentRate = 0;
      } else {
        this.currentRate = parseNumber(Number(this.currentRate));
      }
      if (isNaN(Number(this.rate))) {
        rate = 0;
      } else {
        rate = Number(this.rate);
      }

      if (rate >= 100) {
        rate = 100;
      }

      if (this.currentRate < rate) {
        if (parseInt(rate) == this.currentRate) {
          this.currentRate = parseNumber(this.currentRate + (rate - parseInt(rate)));
        } else {
          this.currentRate = parseNumber(this.currentRate + 1);
        }
      }
    }, 15);
  },

  computed: {
    rateShow() {
      this.rate = this.item.patrolPercentage
      this.currentRate = 0;
      return "";
    },
    styObj() {
      let rotateDeg = "";
      let conicDeg = "";
      if (this.currentRate <= 0) {
        rotateDeg = "rotate(0deg)";
        conicDeg = "0%";
      } else if (this.currentRate > 100) {
        rotateDeg = "rotate(270deg)";
        conicDeg = "0%";
      } else {
        rotateDeg = `rotate(${(this.currentRate / 100) * 270}deg)`;
        conicDeg = `${(this.currentRate / 100) * (270 / 360) * 100}%`;
      }
      return {
        "--pointer-rotate": rotateDeg,
        "--background-wrapper": `conic-gradient(rgba(23, 139, 226, 0.3) 0%, rgba(23, 139, 226, 0.3) ${conicDeg}, transparent ${conicDeg})`,
        "--background-inner": `conic-gradient(#073358 0%, #12a2ff ${conicDeg}, transparent ${conicDeg})`,
      };
    },
  },
  methods: {},
}; 
</script>

<style lang="scss" scoped>
.inner-middle {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .middle-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background: rgba($color: #081A50, $alpha: 1);

    .middle-back {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-image: url('../../assets/homeNew/content18.png');
      background-size: 100% 100%;

      .middle-name {
        width: 100%;
        display: block;
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #fff;
      }

      .middle-msg {
        width: 100%;
        display: block;
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        margin-top: 10px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #B8BABF;
      }
    }
  }

}


.dash-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.outer-border {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 80%;
  border-radius: 50%;
  border: 2px solid #178be2;
  clip-path: polygon(50% 50%, 0 100%, 0 0, 100% 0, 100% 100%);

}

.outer-back {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 8px solid rgba(23, 139, 226, 0.2);
  clip-path: polygon(50% 50%, 0 100%, 0 0, 100% 0, 100% 100%);
}


.inner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95%;
  height: 95%;
  border-radius: 50%;
  background-image: var(--background-wrapper);
  transform: rotate(-135deg);

  /* border: 8px solid rgba(23, 139, 226, 1);
  clip-path: polygon(50% 50%, 0% 100%, 30% 0%, 100% 0%, 60% 100%);*/
}

.inner-border {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  height: 90%;
  border-radius: 50%;
  /*background-image: var(--background-inner);*/
}

.center-box {
  position: relative;
  width: 35%;
  height: 35%;
  background: #091629;
  border-radius: 50%;
}

.center-box::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  height: 80%;
  border: 2px solid #188ff3;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.center-dot {
  position: absolute;
  width: 16px;
  height: 16px;
  left: 50%;
  top: 50%;
  background: #fff;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.center-pointer-wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 75%;
  height: 16px;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.center-pointer {
  width: 50%;
  height: 100%;
  background: #fff;
  clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  transform-origin: right center;
  transform: var(--pointer-rotate);
}

.line-tick {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80%;
  height: 2px;
}

.tick {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 10px;
  background: #00A7FF;
}

.num {
  position: absolute;
  width: 30px;
  left: -32px;
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
  color: #073a6f;
  font-size: 18px;
}

.line-tick1 {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.line-tick1-1 {
  transform: translate(-50%, -50%) rotate(-31.5deg);
}

.line-tick1-2 {
  transform: translate(-50%, -50%) rotate(-18deg);
}

.line-tick1-3 {
  transform: translate(-50%, -50%) rotate(-4.5deg);
}

.line-tick2 {
  transform: translate(-50%, -50%) rotate(9deg);
}

.line-tick2-1 {
  transform: translate(-50%, -50%) rotate(22.5deg);
}

.line-tick2-2 {
  transform: translate(-50%, -50%) rotate(36deg);
}

.line-tick2-3 {
  transform: translate(-50%, -50%) rotate(49.5deg);
}

.line-tick3 {
  transform: translate(-50%, -50%) rotate(63deg);
}

.line-tick3-1 {
  transform: translate(-50%, -50%) rotate(76.5deg);
}

.line-tick3-2 {
  transform: translate(-50%, -50%) rotate(90deg);
}

.line-tick3-3 {
  transform: translate(-50%, -50%) rotate(103.5deg);
}

.line-tick4 {
  transform: translate(-50%, -50%) rotate(117deg);
}

.line-tick4-1 {
  transform: translate(-50%, -50%) rotate(130.5deg);
}

.line-tick4-2 {
  transform: translate(-50%, -50%) rotate(144deg);
}

.line-tick4-3 {
  transform: translate(-50%, -50%) rotate(157.5deg);
}

.line-tick5 {
  transform: translate(-50%, -50%) rotate(171deg);
}

.line-tick5-1 {
  transform: translate(-50%, -50%) rotate(184.5deg);
}

.line-tick5-2 {
  transform: translate(-50%, -50%) rotate(198deg);
}

.line-tick5-3 {
  transform: translate(-50%, -50%) rotate(211.5deg);
}

.line-tick6 {
  transform: translate(-50%, -50%) rotate(225deg);
}

.line-tick1 .num {
  transform: translateY(-50%) rotate(45deg);
}

.line-tick2 .num {
  transform: translateY(-50%) rotate(-10deg);
}

.line-tick3 .num {
  transform: translateY(-50%) rotate(-64deg);
}

.line-tick4 .num {
  transform: translateY(-50%) rotate(-115deg);
}

.line-tick5 .num {
  transform: translateY(-50%) rotate(-171deg);
}

.line-tick6 .num {
  transform: translateY(-50%) rotate(134deg);
}

.slot-content {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
}

.slot-text {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.dash-box-mian {
  position: relative;
  margin: 0 auto !important;
  width: 320px;
  height: 320px;
}

@media screen and (max-width: 1600px) {
  .dash-box-mian {
    position: relative;
    width: 270px;
    height: 270px;

    .inner-middle {
      .middle-content {
        .middle-back {

          .middle-name {
            font-size: 24px;
            line-height: 24px;
          }

          .middle-msg {
            font-size: 12px;
            line-height: 12px;
            margin-top: 7px;
          }
        }
      }

    }

  }
}
</style> 